import { render, staticRenderFns } from "./BASnackbar.vue?vue&type=template&id=72bd9b2d&scoped=true&"
import script from "./BASnackbar.vue?vue&type=script&lang=ts&"
export * from "./BASnackbar.vue?vue&type=script&lang=ts&"
import style0 from "./BASnackbar.vue?vue&type=style&index=0&id=72bd9b2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd9b2d",
  null
  
)

export default component.exports